import { render, staticRenderFns } from "./chatDialog.vue?vue&type=template&id=652d35fe&scoped=true"
import script from "./chatDialog.vue?vue&type=script&lang=ts"
export * from "./chatDialog.vue?vue&type=script&lang=ts"
import style0 from "./chatDialog.vue?vue&type=style&index=0&id=652d35fe&prod&lang=stylus&scoped=true"
import style1 from "./chatDialog.vue?vue&type=style&index=1&id=652d35fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d35fe",
  null
  
)

export default component.exports